import styled from "@emotion/styled";

export const ContentSummaryContainer = styled.p`
  word-break: break-word;
`;
